import React from "react";

function Footer({ t }) {
  return (
    <footer className="footer">
      <p className="footer__tagline">{t.footer.tagline}</p>
      <div className="footer__copy">{t.footer.copy}</div>
      <div className="footer__credit">
        {t.footer.builtBy} <a href="https://craftech.nl" target="_blank" rel="noopener noreferrer" className="footer__credit-link">CrafTech.nl</a>
      </div>
    </footer>
  );
}

export default Footer;
